// extracted by mini-css-extract-plugin
export default {"title":"Hmf3E_Ufpm","tabContent":"b6WuUmgOjI"};